import { message, notification } from 'antd'
import i18n from 'i18next'
import _ from 'lodash'
import { generateMessageError } from 'modules/core/utils'

export const onDeleteReport = ({
  setIsLoading,
  deleteReport,
  onRefetch,
  onClose,
  sendUserDataToGTM,
}) => {
  setIsLoading(true)
  deleteReport()
    .then(() =>
      onRefetch().then(() => {
        message.success(i18n.t('FEEDBACK_DELETE_DATA_SUCCESS'), 8)
        onClose()
        sendUserDataToGTM()
      }),
    )
    .catch((error) => {
      notification.error({
        message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
        description: generateMessageError(error, 'FEEDBACK_DELETE_FAIL'),
        duration: 0,
      })
      onClose()
    })
}

export const onSave = ({
  dataCellEdit,
  setIsLoading,
  editReportName,
  onRefetch,
  onClose,
  sendUserDataToGTM,
}) => {
  if (!_.isEmpty(dataCellEdit)) {
    setIsLoading(true)
    editReportName()
      .then(() =>
        onRefetch().then(() => {
          message.success(i18n.t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
          onClose()
          sendUserDataToGTM()
        }),
      )
      .catch(() => {
        notification.error({
          message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
          description: i18n.t('FEEDBACK_SAVE_CHANGES_FAIL'),
          duration: 0,
        })
        onClose()
      })
  }
}
